import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Benefit } from '../@types/benefits';
import {
  getNotifications,
  clearNotificationMarker,
  acknowledgeNotification,
} from '../api/notifications/getNotifications';

export const useGetNotifications = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
  });

  return {
    initializing: isLoading || isFetching || isError,
    notifications: data,
  };
};

export const useClearNotificationMarker = () => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess } = useMutation(
    async (benefitId: Benefit) => {
      const data = await clearNotificationMarker(benefitId);
      return data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['notifications']),
    },
  );
  return { clearNotificationMarker: mutate, isClearNotificationMarkerSuccess: isSuccess };
};

export const useAcknowledgeNotification = () => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess } = useMutation(
    async (props: { benefitId: Benefit; notificationId: string }) => {
      const { benefitId, notificationId } = props;
      const data = await acknowledgeNotification({ benefitId, notificationId });
      return data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['notifications']),
    },
  );
  return { acknowledgeNotification: mutate, isAcknowledgeNotificationSuccess: isSuccess };
};
